import React from 'react';
import ReactDOM from 'react-dom';
import DashboardActionsMenu from 'common/components/dashboard-actions-menu';
import {reactDOMInject} from 'common/utils/dom-util';

window.addEventListener('dashboard-actions-menu:rerender', render);
window.addEventListener('dashboard-settings-updated', renderUpdated);

render();

function parseIfStr(val) {
  if (typeof val === 'string') {
    return JSON.parse(val);
  }
  return val;
}

function render() {
  reactDOMInject(DashboardActionsMenu, '.dashboard-actions-menu', (data) => {
    return {
      ...data,
      dashboard: parseIfStr(data.dashboard),
      showActionEdit: parseIfStr(data.showActionEdit),
      userCanEditDashboard: parseIfStr(data.userCanEditDashboard),
      usedInAStoryboard: parseIfStr(data.usedInAStoryboard),
    };
  });
}

function renderUpdated(evnt) {
  const {dashboard, userCanEditDashboard} = evnt.detail;

  reactDOMInject(
    DashboardActionsMenu,
    `#dashboard-actions-menu--${dashboard.id}`,
    (data) => {
      return {
        ...data,
        dashboard: parseIfStr(data.dashboard),
        showActionEdit: parseIfStr(data.showActionEdit),
        userCanEditDashboard: parseIfStr(data.userCanEditDashboard),
        usedInAStoryboard: parseIfStr(data.usedInAStoryboard),
      };
    },
  );
}
